// 优惠券 status: 1=有效=未领取  2=已领取/未使用  3=已使用  4=已过期 5=已领完 6 继续领取 7：已超限
export const emptyStatus = 5;
export const timeoutStatus = 4;
export const usedStatus = 3;
export const receiveStatus = 2;
export const canReceiveStatus = 1;
export const continueReceiveStatus = 6;

export const activeStatus = [canReceiveStatus, receiveStatus, continueReceiveStatus]; // 优惠券有效状态(ui高亮)
export const unReceiveStatus = [canReceiveStatus, continueReceiveStatus]; // 优惠券可领取状态

export const coundownMaxDay = 4; // 倒计时显示天数

export const urlObjs = [
    {
        route: 'home',
        nativeTab: 'shouye',
        link: '/new/#/home',
        miniPath: '/pages/index/index?tab=home',
    },
    {
        route: 'shop',
        nativeTab: 'shop',
        link: '/new/#/shop',
        miniPath: '/pages/index/index?tab=shop',
    },
    {
        route: 'privilege',
        nativeTab: 'vip',
        link: '/new/#/privilege',
        miniPath: '/pages/index/index?tab=privilege',
    },
    {
        route: 'package',
        nativeTab: 'home',
        link: '/new/#/package',
        miniPath: '/pages/index/index?tab=privilege',
    },
    {
        route: 'mine',
        nativeTab: 'mine',
        link: '/new/#/mine',
        miniPath: '/pages/index/index?tab=mine',
    },
];
